import { ChevronDown, ChevronRight, History } from "lucide-react";
import { useState } from "react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { formatCurrency } from "@/lib/utils";

import type { ProductRecipe } from "@artisancode/api-types";

interface Props {
  recipes: ProductRecipe[];
  isActivating: boolean;
  onActivate: (recipeId: string) => void;
}

/** Collapsible list of recipe versions with "Aktifkan Kembali" for archived ones. */
export function ProductRecipeHistorySection({
  recipes,
  isActivating,
  onActivate,
}: Props) {
  const [showHistory, setShowHistory] = useState(false);
  if (recipes.length === 0) return null;

  return (
    <div className="border rounded-lg p-2.5 bg-muted/20">
      <button
        type="button"
        onClick={() => setShowHistory(!showHistory)}
        className="flex w-full items-center justify-between text-xs font-semibold text-muted-foreground hover:text-foreground"
      >
        <span className="flex items-center gap-1.5">
          <History className="h-3.5 w-3.5 text-muted-foreground" />
          Riwayat Versi Resep ({recipes.length} versi)
        </span>
        {showHistory ? (
          <ChevronDown className="h-4 w-4" />
        ) : (
          <ChevronRight className="h-4 w-4" />
        )}
      </button>

      {showHistory && (
        <div className="mt-2.5 space-y-2 border-t pt-2">
          {recipes.map((rec) => (
            <div
              key={rec.id}
              className="flex items-center justify-between rounded-md border bg-background p-2"
            >
              <div>
                <div className="flex items-center gap-1.5">
                  <span className="font-semibold text-foreground">
                    Versi {rec.version}
                  </span>
                  {rec.isActive ? (
                    <Badge variant="default" className="text-[10px] h-4">
                      Aktif
                    </Badge>
                  ) : (
                    <Badge
                      variant="outline"
                      className="text-[10px] h-4 text-muted-foreground"
                    >
                      Arsip
                    </Badge>
                  )}
                </div>
                <p className="text-[11px] text-muted-foreground mt-0.5">
                  HPP saat dibuat: {formatCurrency(rec.computedCogs)} |{" "}
                  {rec.items?.length || 0} bahan | Yield: {rec.yieldQty}
                </p>
              </div>

              {!rec.isActive && (
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  disabled={isActivating}
                  onClick={() => onActivate(rec.id)}
                  className="h-7 text-[11px]"
                >
                  Aktifkan Kembali
                </Button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
